import { requestJson } from '@/shared/api/http'
import type { NetworkRange, TopicNetworkResponse } from '../model/contracts'
import { parseTopicNetworkResponse } from './networkCodec'

export async function fetchTopicNetwork(
  topicId: string,
  range: NetworkRange,
  signal?: AbortSignal,
): Promise<TopicNetworkResponse> {
  const params = new URLSearchParams({ range })
  return requestJson<TopicNetworkResponse>(
    `/api/v1/topics/${topicId}/network?${params.toString()}`,
    { method: 'GET', signal },
  ).then(parseTopicNetworkResponse)
}
